//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { MappingProvider } from "../mapping/mappingProvider.component";
import { ThemeProvider } from "../theme/themeProvider.component";
export class StyleProvider extends React.PureComponent {
  render() {
    const {
      styles,
      theme,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(MappingProvider, {
      styles: styles
    }, /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: theme
    }, children));
  }

}